import styled from 'styled-components';
const MyDiv = styled.div`
 
  .btn {
    background: rgba(0, 104, 56, 1);
    color: white;
    &:hover {
      background: rgba(0, 104, 56, 0.9);
      color: white;
    }
  }
 
`;
export default MyDiv;
